<ion-content class="ion-padding">
  <ion-toolbar color="translucent">
    <ion-buttons slot="start" class="modalBack">
      <ion-button fill="clear" (click)="goBack()">
          <ion-icon class="back-button" src="assets/imgs/Icon-akar-arrow-left.svg" alt="Veggly Logo"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="badgeContainer">
    <div class="titleBadge">
      <!-- <ion-badge>
        {{ 'signUp' | translate }}
      </ion-badge> -->
    </div>
  </div>

  <div class="imgDiv">
    <img src="assets/imgs/logo_novo.svg" alt="Veggly Logo">
  </div>

  <div class="welcome">
    {{ 'emailValidation' | translate }}
  </div>



  <div class="enterEmailPass">
    <p>
      <!-- {{ 'enterEmailPassValidationCodeWillBeSent' | translate }} -->
    </p><br>
  </div>

  <div class="formSection">
    <ion-list>
      <div class="fillyourdetails">
        <div class="weHaveSentText">
          <p>{{ 'weHaveSent' | translate }} <b>{{ email ? email : 'your email' }}</b>{{ 'aTemp6digitCode' | translate }}
          </p>
          <p class="checkSpamFolder" *ngIf="('checkSpamFolder' | translate) as checkSpamFolder">
            <b>{{ checkSpamFolder }}</b>
          </p>
        </div>
      </div>

      <div class="code-container">
        <!-- Input fields for the code -->
        <ion-row>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[0]" #input1 maxlength="1"
              inputmode="numeric" class="code-input" (ionInput)="moveFocus($event, input2)"
              (keydown)="moveBack($event, null)" (paste)="handlePaste($event)"></ion-input>
          </ion-col>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[1]" #input2 maxlength="1"
              inputmode="numeric" class="code-input" (ionInput)="moveFocus($event, input3)"
              (keydown)="moveBack($event, input1)"></ion-input>
          </ion-col>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[2]" #input3 maxlength="1"
              inputmode="numeric" class="code-input" (ionInput)="moveFocus($event, input4)"
              (keydown)="moveBack($event, input2)"></ion-input>
          </ion-col>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[3]" #input4 maxlength="1"
              inputmode="numeric" class="code-input" (ionInput)="moveFocus($event, input5)"
              (keydown)="moveBack($event, input3)"></ion-input>
          </ion-col>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[4]" #input5 maxlength="1"
              inputmode="numeric" class="code-input" (ionInput)="moveFocus($event, input6)"
              (keydown)="moveBack($event, input4)"></ion-input>
          </ion-col>
          <ion-col size="2">
            <ion-input [ngClass]="{'invalid-code': isInvalid}" [(ngModel)]="code[5]" #input6 maxlength="1"
              inputmode="numeric" class="code-input" (keydown)="moveBack($event, input5)"></ion-input>
          </ion-col>
        </ion-row>
      </div>

    </ion-list>
  </div>

  <div class="bottomButtons">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="full" class="buttonShadow" color="primary" shape="round" fill="solid"
            (click)="validateCode()">
            {{ 'validate' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="notAUserBtn" (click)="sendAgain()">
            <span class="getNewCode">{{ 'getNewCode' | translate }}</span>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

  </div>

</ion-content>